import './Link-e01bdaee.css';

var classes = {"Link":"prc-Link-Link-85e08"};

export { classes as default };
